import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { FilterChipsProps } from './types';
import { StyledTag } from '../StyledTag';

const FilterChips: FC<FilterChipsProps> = ({ filterKey, values, onRemove }) => {
  const renderChips = () => {
    switch (filterKey) {
      case 'location': {
        if (!values) return null;
        return <StyledTag label={values as string} onDelete={() => onRemove(filterKey)} />;
      }

      case 'years_of_experience': {
        if (!values) return null;
        return (
          <StyledTag label={`${values as number} years`} onDelete={() => onRemove(filterKey)} />
        );
      }

      case 'job_titles':
      case 'industries': {
        if (!Array.isArray(values)) return null;
        return (values as string[]).map((value: string, index: number) => (
          <StyledTag
            key={`${filterKey}-${value}-${index}`}
            label={value}
            onDelete={() => onRemove(filterKey, index)}
          />
        ));
      }

      case 'skills': {
        if (!Array.isArray(values)) return null;
        return (values as string[][]).map((skillGroup, groupIndex) =>
          skillGroup.map((skill, skillIndex) => (
            <StyledTag
              key={`skills-${skill}-${groupIndex}-${skillIndex}`}
              label={skill}
              onDelete={() => onRemove(filterKey, groupIndex, skillIndex)}
            />
          ))
        );
      }

      default:
        return null;
    }
  };

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {renderChips()}
    </Stack>
  );
};

export default FilterChips;
